import { render, staticRenderFns } from "./PointsCounter.vue?vue&type=template&id=35127642&scoped=true&"
import script from "./PointsCounter.vue?vue&type=script&lang=js&"
export * from "./PointsCounter.vue?vue&type=script&lang=js&"
import style0 from "./PointsCounter.vue?vue&type=style&index=0&id=35127642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35127642",
  null
  
)

export default component.exports